import { sessionStore } from "@/Globals/Stores/SessionStore";
import { CancellableWorkflowStep } from "../../BaseWorkflow/Steps/CancellableWorkflowStep";
import { LoginWorkflowStepEnum } from "../LoginWorkflowStepEnum";

class ChangeTempPasswordStep extends CancellableWorkflowStep<LoginWorkflowStepEnum> {
    public constructor() {
        super(LoginWorkflowStepEnum.ChangeTempPassword);
    }

    public isValid(): boolean {
        return sessionStore.isTempPassword; // This step will occur only if the user has not changed his temporary password
    }

    public isCompleted(): boolean {
        return !sessionStore.isTempPassword;
    }

    public cancel(): void {
        sessionStore.action.logout(false); // This step is mandatory for the user to complete
    }
}

export { ChangeTempPasswordStep };
